var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08203 9.91683V7.5835",
    stroke: "#808080",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.91683V4.0835",
    stroke: "#808080",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91797 9.9165V6.4165",
    stroke: "#808080",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45703 7.00016C1.45703 4.3878 1.45703 3.08162 2.26859 2.27005C3.08015 1.4585 4.38633 1.4585 6.9987 1.4585C9.61104 1.4585 10.9172 1.4585 11.7288 2.27005C12.5404 3.08162 12.5404 4.3878 12.5404 7.00016C12.5404 9.6125 12.5404 10.9187 11.7288 11.7303C10.9172 12.5418 9.61104 12.5418 6.9987 12.5418C4.38633 12.5418 3.08015 12.5418 2.26859 11.7303C1.45703 10.9187 1.45703 9.6125 1.45703 7.00016Z",
    stroke: "#808080",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analyticsIcon.05ebc75497b025802b012b889a396eea.svg";
export { ForwardRef as ReactComponent };